import { useLocation } from "react-router-dom";
import { parseQueryString } from "../utils/queryString";

export function useGarageIdFromLocation() {
  const location = useLocation();
  const query = parseQueryString(location.search);

  return query.garage_id;
}
